module.exports = __webpack_public_path__ + "static/media/tela3.2ce6d4e3.png";